import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ui-icon',
  template: '{{icon}}',
  styles: `
    :host {
      display: inline-block;
    }
  `,
})
export class IconComponent {
  @Input({ required: true }) public icon!: string;

  @HostBinding('class.filled')
  @Input()
  public filled = false;

  @HostBinding('class') public class = 'material-symbols-outlined';
}
